const ensureObject = require('utils/lib/validation/ensureObject').default;

const getAttendanceOverviewCounts = (attendance) => {
  const {numberOfNotSet, numberOfNotAttend, numberOfAttend} = ensureObject(
    attendance,
  );

  return {
    notMarked: numberOfNotSet,
    attended: numberOfAttend,
    absent: numberOfNotAttend,
  };
};

module.exports = {
  getAttendanceOverviewCounts,
};
